// eslint-disable-next-line import/prefer-default-export
export const formatDate = (
  timestamp,
  dateStyle = 'medium',
  timeStyle = 'long',
) => new Date(timestamp).toLocaleString('en-us', { dateStyle, timeStyle });

export const formatTime = (
  timestamp,
  timeStyle = 'short',
) => new Date(timestamp).toLocaleTimeString('en-us', { timeStyle });

export const formatMonthAndDay = (
  timestamp,
  monthStyle = 'short',
  dayStyle = 'numeric',
) => new Date(timestamp).toLocaleString('en-us', { month: monthStyle, day: dayStyle });

export const formatMonthDayYear = (
  timestamp,
  monthStyle = 'numeric',
  dayStyle = 'numeric',
  yearStyle = 'numeric',
) => new Date(timestamp).toLocaleString('en-us', { month: monthStyle, day: dayStyle, year: yearStyle });

export const formatRelativeTime = (timestamp) => {
  const now = new Date();
  const date = new Date(timestamp);
  const diffInSeconds = Math.floor((date - now) / 1000);
  const isFuture = diffInSeconds > 0;
  const absDiffInSeconds = Math.abs(diffInSeconds);

  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

  if (absDiffInSeconds < 60) {
    return rtf.format(isFuture ? absDiffInSeconds : -absDiffInSeconds, 'second');
  }

  const diffInMinutes = Math.floor(absDiffInSeconds / 60);
  if (diffInMinutes < 60) {
    return rtf.format(isFuture ? diffInMinutes : -diffInMinutes, 'minute');
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return rtf.format(isFuture ? diffInHours : -diffInHours, 'hour');
  }

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 30) {
    return rtf.format(isFuture ? diffInDays : -diffInDays, 'day');
  }

  const diffInMonths = Math.floor(diffInDays / 30);
  if (diffInMonths < 12) {
    return rtf.format(isFuture ? diffInMonths : -diffInMonths, 'month');
  }

  const diffInYears = Math.floor(diffInMonths / 12);
  return rtf.format(isFuture ? diffInYears : -diffInYears, 'year');
};
